/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckAIcon16Regular = forwardRef('CheckAIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M14.895 3.595a.75.75 0 0 1 0 1.06l-6.833 6.833a2.337 2.337 0 0 1-3.306 0L2.22 8.95a.75.75 0 0 1 1.06-1.06l2.537 2.536a.838.838 0 0 0 1.185 0l6.832-6.832a.75.75 0 0 1 1.06 0Z" })));
});
